import React from "react"
import { observer } from "mobx-react"
import { useStore } from "@features/common"

import { SmartBannerIllustration } from "../atoms"
import { SmartBannerLogo } from "../atoms/smart-banner-logo"
import {
  SmartBannerButton,
  SmartBannerButtonAndroid,
  SmartBannerCloseButton,
} from "../molecules"

import type { MouseEvent } from "react"

export const SmartBanner = observer(function SmartBanner() {
  const {
    GlobalModel: {
      smartBanner,
      closeSmartBanner,
      setIsSmartBannerDisabled,
      setSmartBannerDisabledCookie,
    },
    ResponsiveModel,
  } = useStore()

  const handleClose = (e: MouseEvent) => {
    e.stopPropagation()
    setSmartBannerDisabledCookie()
    setIsSmartBannerDisabled(true)
    closeSmartBanner()
  }

  const handleBannerClick = () => {
    if (smartBanner.link) {
      window.location.href = smartBanner.link
    }
  }

  const handleButtonClick = (e: MouseEvent) => {
    e.stopPropagation()
  }

  return (
    <div
      onClick={handleBannerClick}
      className="relative flex items-center mobile:h-auto pl-11 pr-3 bg-gold-200 tablet:justify-center cursor-pointer"
      data-test-id="smart_banner"
    >
      <SmartBannerCloseButton
        className="absolute left-3"
        onClick={handleClose}
        data-test-id="smart_banner__close_button"
      />
      <SmartBannerIllustration className="hidden tablet:block w-[53px] h-12 mr-3.5 my-0.5" />
      <div className="w-26 flex flex-shrink-0 flex-col tablet:w-auto tablet:flex-row tablet:items-center">
        <SmartBannerLogo className="fill-black h-4.5 mb-1.5 tablet:h-3.5 tablet:w-[63px] tablet:mb-0 tablet:mr-2" />
        <div className="font-sans-bold uppercase text-xs tablet:text-sm tablet:font-sans tablet:tracking-[1px] tablet:mt-[3px] tablet:mr-3.5">
          {smartBanner.description}
        </div>
      </div>
      {ResponsiveModel.isAndroid ? (
        <div
          className={
            "inline-flex flex-row flex-wrap justify-end tablet:justify-center items-center grow h-[80px] tablet:h-auto tablet:space-x-2"
          }
        >
          <SmartBannerButtonAndroid
            onClick={handleButtonClick}
            href={smartBanner.playmarketLink || undefined}
            data-test-id="smart_banner__googleplay_button"
          >
            {smartBanner.playmarketButtonText}
          </SmartBannerButtonAndroid>
          <SmartBannerButtonAndroid
            onClick={handleButtonClick}
            href={smartBanner.appgalleryLink || undefined}
            data-test-id="smart_banner__appgallery_button"
          >
            {smartBanner.appgalleryButtonText}
          </SmartBannerButtonAndroid>
        </div>
      ) : (
        <React.Fragment>
          <div className="tablet:hidden flex grow justify-center h-[80px] tablet:h-auto">
            <SmartBannerIllustration className="hidden mobile-s:block mobile-s:w-21 mobile-m:w-23.5" />
          </div>
          <SmartBannerButton
            onClick={handleButtonClick}
            href={smartBanner.link || undefined}
            data-test-id="smart_banner__button"
          >
            {smartBanner.buttonText}
          </SmartBannerButton>
        </React.Fragment>
      )}
    </div>
  )
})
